import BrowsingGalleryView from './BrowsingGalleryView';

export default BrowsingGalleryView;
